import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const catalogosRoutes: Routes = [
  {
    path: 'catalogo-tipos',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.CATALOGO_TIPOS_VER, Permiso.CATALOGO_TIPOS_GESTIONAR] },
    loadComponent: () =>
      import('./pages/catalogo-tipos/catalogo-tipos.page').then((m) => m.CatalogoTiposPage),
    title: 'SiLabVet | Tipos de catálogo',
  },
  {
    path: 'catalogo-tipos/nuevo',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.CATALOGO_TIPOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/catalogo-tipos/catalogo-tipo-form.page').then((m) => m.CatalogoTipoFormPage),
    title: 'SiLabVet | Nuevo tipo de catálogo',
  },
  {
    path: 'catalogo-tipos/:id/editar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.CATALOGO_TIPOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/catalogo-tipos/catalogo-tipo-form.page').then((m) => m.CatalogoTipoFormPage),
    title: 'SiLabVet | Editar tipo de catálogo',
  },
  {
    path: 'catalogos',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.CATALOGOS_VER, Permiso.CATALOGOS_GESTIONAR] },
    loadComponent: () => import('./pages/catalogos/catalogos.page').then((m) => m.CatalogosPage),
    title: 'SiLabVet | Catálogos',
  },
  {
    path: 'catalogos/nuevo',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.CATALOGOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/catalogos/catalogo-form.page').then((m) => m.CatalogoFormPage),
    title: 'SiLabVet | Nuevo catálogo',
  },
  {
    path: 'catalogos/:id/editar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.CATALOGOS_GESTIONAR },
    loadComponent: () =>
      import('./pages/catalogos/catalogo-form.page').then((m) => m.CatalogoFormPage),
    title: 'SiLabVet | Editar catálogo',
  },
];
